import { css } from '@emotion/css'
import { spacing, borderRadius } from '../../../styles'
import { colors } from '../../../themes'

const styles = {
  header: css({
    color: colors.oxfordBlue,
    backgroundColor: colors.athensGray,
  }),

  row: css({
    '& > th:first-child': {
      borderTopLeftRadius: borderRadius.default,
    },

    '& > th:last-child': {
      borderTopRightRadius: borderRadius.default,
    },
  }),

  cell: css({
    textAlign: 'left',
    padding: spacing.default,
    userSelect: 'none',
  }),

  sortable: css({
    cursor: 'pointer',

    '&:focus': {
      outline: 'none',
      textDecoration: 'underline',
    },

    '& > *': {
      verticalAlign: 'middle',
    },

    '& > * + *': {
      marginLeft: spacing.small,
    },
  }),
}

export default styles

export const cellAlignment = alignment =>
  css({
    textAlign: alignment || 'left',
  })
